/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import withBlockCanDismiss from './blockCanDismiss';
import OnboardingArticles3 from 'src/components/views/dashboard/onboardingArticles/onboardingArticles3';
import OnboardingArticles4 from 'src/components/views/dashboard/onboardingArticles/onboardingArticles4';

import * as checklistActions from 'actions/dashboard/checklist-actions';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;
class OnboardingArticles extends Component<ComposedProps> {
  componentDidMount() {
    const { getChecklist } = this.props;

    // Get list of checklist
    getChecklist();
  }

  renderContentArticle = () => {
    const { name, style } = this.props;
    switch (style) {
      case 3:
        return <OnboardingArticles3 name={name} />;
      case 1:
      case 2:
      case 4:
        return <OnboardingArticles4 />;
      default:
        return '';
    }
  };

  render() {
    const { renderPopover, i18n, style } = this.props;

    return style ? (
      <div className="BC-OnboardingArticles">
        <Card>
          <Card.Header title={i18n.translate('AdminHTML.Dashboard.Common.whatSNext')}>
            <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
          </Card.Header>
          <Card.Section>{this.renderContentArticle()}</Card.Section>
        </Card>
      </div>
    ) : (
      ''
    );
  }
}

const mapStateToProps = (state, props) => ({
  loading: _.get(state.checklist, 'loading', false),
  success: _.get(state.checklist, 'success', false),
  name: _.get(state.checklist, 'name', ''),
  style: _.get(state.checklist, 'style', 4)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getChecklist: () => dispatch(checklistActions.getChecklist(ownProps.i18n))
});

export default withBlockCanDismiss(
  withI18n()(connect(mapStateToProps, mapDispatchToProps)(OnboardingArticles))
);
